import React from "react"
import SmartLink from "../../../../../layout/SmartLink/SmartLink"
import { InlineText } from "../../../../../Typography/Typography"
import {
  generateGeoPathData,
  geoAreaLocationProviderDirectoryPath,
  providerProfileURL,
} from "../../../../../../utils/paths"

const dementiaCareHomeLink = (link, text, clickEvent) => (
  <SmartLink to={link} clickEvent={clickEvent}>
    <InlineText brand>{text}</InlineText>
  </SmartLink>
)

const dementiaLinkClickEvent = {
  name: "SEO - Filtered Directory - FAQs Dementia Care Home Link Clicked",
}

const dementiaCareHomeAnswerText = (locationName, dementiaCareHomeCount) =>
  dementiaCareHomeCount === 1
    ? `There is only 1 care home in ${locationName} who offers specialist dementia care, this is `
    : `There are ${dementiaCareHomeCount} care homes in ${locationName} who offer specialist dementia care for more information on the specific homes, `

const dementiaProviderProfileLink = (dementiaBranchRecords, answerType) => {
  const { name, regulatoryId, regulatoryBody } = dementiaBranchRecords[0]

  return answerType === "structuredDataAnswer"
    ? name
    : dementiaCareHomeLink(
        providerProfileURL(regulatoryId, regulatoryBody, name),
        name,
        dementiaLinkClickEvent,
      )
}

const dementiaCareHomePageLink = (
  answerType,
  locationName,
  geographicScale,
) => {
  const text = "view our dementia care home list"
  const link = geoAreaLocationProviderDirectoryPath(
    generateGeoPathData(geographicScale, locationName, "care_home"),
    "dementia",
  )

  return answerType === "structuredDataAnswer"
    ? text
    : dementiaCareHomeLink(link, text, dementiaLinkClickEvent)
}

const dementiaFilteredBranchRecords = (branchRecords) =>
  branchRecords.filter((branchRecord) =>
    branchRecord.careServiceTypes.includes("Dementia"),
  )

const dementiaAnswerLink = (
  dementiaBranchRecords,
  dementiaCareHomeCount,
  answerType,
  locationName,
  geographicScale,
) =>
  dementiaCareHomeCount === 1
    ? dementiaProviderProfileLink(dementiaBranchRecords, answerType)
    : dementiaCareHomePageLink(answerType, locationName, geographicScale)

// eslint-disable-next-line import/prefer-default-export
export const dementiaCareHomeQA = (
  locationName,
  dementiaCareHomeCount,
  branchRecords,
  geographicScale,
) => {
  const dementiaBranchRecords = dementiaFilteredBranchRecords(branchRecords)

  return {
    question: `How many care homes in ${locationName} specialise in dementia care?`,
    answer: (
      <>
        {dementiaCareHomeAnswerText(locationName, dementiaCareHomeCount)}
        {dementiaAnswerLink(
          dementiaBranchRecords,
          dementiaCareHomeCount,
          "normal",
          locationName,
          geographicScale,
        )}
        .
      </>
    ),
    structuredDataAnswer: `${dementiaCareHomeAnswerText(
      locationName,
      dementiaCareHomeCount,
    )} ${dementiaAnswerLink(
      dementiaBranchRecords,
      dementiaCareHomeCount,
      "structuredDataAnswer",
      locationName,
      geographicScale,
    )}.`,
  }
}
